import { Navigate } from 'react-router-dom';

// Define a permissions object mapping user types to their permissions
const permissions = {
  employee: ['viewDashboard', 'editProfile', 'viewAudiences'],
  customer: ['viewProducts', 'purchase'],
  partner: ['viewPartners', 'managePartners'],
  // Add more user types and their permissions as needed
};

const ProtectedRoute = ({ children, requiredPermissions, userType }) => {
  // Get the permissions for the current user type
  const userPermissions = permissions[userType] || [];

  // Check if user has at least one of the required permissions
  const hasAccess = requiredPermissions.some(perm =>
    userPermissions.includes(perm),
  );

  // TODO: Uncomment this when we have a proper unauthorized page
  // if (!hasAccess) {
  //   return <Navigate to="/unauthorized" />;
  // }

  return children;
};

export default ProtectedRoute;
